<template>
  <div>All Email Templates</div>
</template>
<script>
export default {
  name: 'all_email_templates',
  components: {},
  data() {
    return {}
  },
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  watch: {},
  methods: {},
}
</script>
<style scoped lang="scss"></style>
<style lang="scss"></style>
